import { render } from "./TicketTv.vue?vue&type=template&id=2ead0f94&scoped=true"
import script from "./TicketTv.vue?vue&type=script&lang=js"
export * from "./TicketTv.vue?vue&type=script&lang=js"

import "./TicketTv.vue?vue&type=style&index=0&id=2ead0f94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ead0f94"]])

export default __exports__